var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNightfall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "auto",
    height: "auto",
    viewBox: "0 0 128 128",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.828
    },
    fill: "current",
    stroke: "current",
    d: "M24.5 23.5h13a8439.42 8439.42 0 0 0 5.5 80l-1-1a101.9 101.9 0 0 0-4-15 72.317 72.317 0 0 0-11-5c-1.745-3.548-1.579-7.048.5-10.5a37.12 37.12 0 0 1-2-4.5c1.76-1.254 3.26-.92 4.5 1 1.337 3.526 1.837 7.192 1.5 11 2.412.256 4.08-.744 5-3a864.024 864.024 0 0 1-4.5-18L29.5 56c-14.512 2.173-19.512-3.494-15-17a20.01 20.01 0 0 0-4-8.5c3.199-.09 6.032 1.243 8.5 4a168.855 168.855 0 0 1 1.5 8c.047 2.712-.953 4.878-3 6.5l1.5 1.5c4.726-1.891 7.892-5.224 9.5-10a104.93 104.93 0 0 1-4-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.89
    },
    fill: "current",
    stroke: "current",
    d: "M43.5 24.5c5.485-1.152 11.151-1.318 17-.5l-7 7c4.949-.977 9.282-3.31 13-7 5.323-.5 10.656-.666 16-.5.202 2.49-.298 4.823-1.5 7l-13 11A159.095 159.095 0 0 1 54.5 58c-2.318 1.993-4.984 3.16-8 3.5a377.738 377.738 0 0 0-3-37Zm14 12c1.941 1.51 2.441 3.51 1.5 6-2.215 1.32-3.715.653-4.5-2 .672-1.66 1.672-2.993 3-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.829
    },
    fill: "current",
    stroke: "current",
    d: "M89.5 23.5h13a189.483 189.483 0 0 0-3.5 19c2.038 4.732 5.538 6.9 10.5 6.5a9.465 9.465 0 0 1-2.5-1.5c-2.775-8.78.059-14.78 8.5-18l1 1c-2.546 2.258-3.879 5.092-4 8.5 4.456 13.559-.544 19.225-15 17a4.452 4.452 0 0 0-2 1.5 397.767 397.767 0 0 0-5 19c1.334 2.495 3.334 3.662 6 3.5-1.122-3.409-1.289-6.909-.5-10.5 1.263-2.297 3.097-3.13 5.5-2.5-2.511 3.975-2.511 7.975 0 12l-2 4A37.328 37.328 0 0 0 89 87.5a7921.83 7921.83 0 0 1-5 16c1.856-26.632 3.69-53.3 5.5-80Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.854
    },
    fill: "current",
    stroke: "current",
    d: "M79.5 37.5c2.518 7.873 2.018 15.873-1.5 24a147.36 147.36 0 0 1-12 11A75.4 75.4 0 0 1 57.5 84c-2.476 2.571-5.476 4.071-9 4.5a83.48 83.48 0 0 1 1.5-21c7.755-5.753 14.089-12.753 19-21a76.3 76.3 0 0 1 10.5-9Zm-10 15c3.024-.325 4.69 1.008 5 4-2.06 6.26-4.393 6.427-7 .5a39.175 39.175 0 0 0 2-4.5Zm-12 18c2.47.86 2.637 2.194.5 4-1.768-1.182-1.935-2.515-.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.859
    },
    fill: "current",
    stroke: "current",
    d: "M78.5 67.5c.652.949.986 2.115 1 3.5a6816.823 6816.823 0 0 1-3 32.5 84.9 84.9 0 0 1-13-.5 22.755 22.755 0 0 1 5-4c-3.27.463-6.27 1.796-9 4a40.911 40.911 0 0 1-9 .5c-.344-4.466.823-8.466 3.5-12a825.655 825.655 0 0 1 24.5-24Zm-9 18c2.135-.353 3.468.48 4 2.5-.786 1.988-2.286 3.154-4.5 3.5-1.28-.114-2.113-.78-2.5-2a493.061 493.061 0 0 0 3-4Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightfall);
export default __webpack_public_path__ + "static/media/nightfall.b9b6d791.svg";
export { ForwardRef as ReactComponent };